/**
 * @generated SignedSource<<f43f187c59d26ff1cf11b99b289bc1d8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BuyMobileNavRefineMenuFilters_viewer$data = {
  readonly isMatchedSetsEnabled: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedRefineMenuFilterItemLocation_viewer">;
  readonly " $fragmentType": "BuyMobileNavRefineMenuFilters_viewer";
};
export type BuyMobileNavRefineMenuFilters_viewer$key = {
  readonly " $data"?: BuyMobileNavRefineMenuFilters_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"BuyMobileNavRefineMenuFilters_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BuyMobileNavRefineMenuFilters_viewer",
  "selections": [
    {
      "alias": "isMatchedSetsEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "key",
          "value": "enableMatchedSetsFacet"
        }
      ],
      "kind": "ScalarField",
      "name": "isEnabled",
      "storageKey": "isEnabled(key:\"enableMatchedSetsFacet\")"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterItemLocation_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "d3933f66c901da64a3c71eddfdc329f9";

export default node;
